import { UserRoleViewModel } from '.';
import { endpoint,mappable } from '../decorators';
import { BaseViewModel } from './base-view-model';

@endpoint('user')
export class UserViewModel extends BaseViewModel {
  public HawkId = '';
  public First = '';
  public Middle = '';
  public Last = '';
  public Email = '';
  public Department = '';
  public Title = '';
  public EmailNotifications = true;

  @mappable('UserRoleViewModel')
  public UserRoles: UserRoleViewModel[] = null;

  public get FullName(): string {
    return `${this.First} ${this.Last}`;
  }
  public get LastFirst(): string {
    const lF = `${this.Last ?? ''}, ${this.First ?? ''} ${this.Middle ?? ''}`;
    return lF === ',  ' ? 'No Name' : lF;
  }
  public get RolesSummary(): string {
    return (this.UserRoles || [])
      .filter(
        ur => ur.Role && ur.Role.RoleName && ur.Role.RoleName !== 'ValidUser'
      )
      .map(ur => ur.Role.RoleName)
      .join(', ');
  }
}
